var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.346,
    height: 79.66,
    viewBox: "0 0 65.346 79.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trophy",
    transform: "translate(-46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8047",
    "data-name": "Group 8047",
    transform: "translate(46 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17443",
    "data-name": "Path 17443",
    d: "M233.224,452H226.75a1.556,1.556,0,1,0,0,3.112h6.474a1.556,1.556,0,0,0,0-3.112Z",
    transform: "translate(-197.314 -381.675)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17444",
    "data-name": "Path 17444",
    d: "M109.79,12.447h-9.335V9.068A4.667,4.667,0,0,0,98.9,0H58.447a4.667,4.667,0,0,0-1.556,9.068v3.379H47.556A1.556,1.556,0,0,0,46,14V24.894A12.461,12.461,0,0,0,58.447,37.341h1.315q.449.782.963,1.532a21.887,21.887,0,0,0,8.646,7.374,4.658,4.658,0,0,0,3.493,5.072C70.994,57.548,67.672,64.1,63.737,64.1H60a1.556,1.556,0,0,0-1.544,1.363L56.9,77.911a1.556,1.556,0,0,0,1.544,1.749H98.9a1.556,1.556,0,0,0,1.544-1.749L98.887,65.464A1.556,1.556,0,0,0,97.343,64.1H93.609c-2.382,0-4.394-2.5-5.663-4.6a36.966,36.966,0,0,1-3.464-8.184,4.658,4.658,0,0,0,3.493-5.072,21.887,21.887,0,0,0,8.647-7.375q.515-.748.962-1.531H98.9a12.461,12.461,0,0,0,12.447-12.447V14a1.556,1.556,0,0,0-1.556-1.556ZM49.112,24.894V15.559h7.779V26.567a21.6,21.6,0,0,0,1.4,7.659A9.344,9.344,0,0,1,49.112,24.894ZM97.137,76.548H60.209l1.167-9.335H95.97ZM87.476,64.1H69.871a19.035,19.035,0,0,0,2.185-2.977,41.288,41.288,0,0,0,4.008-9.664h5.219a41.293,41.293,0,0,0,4,9.652A19.048,19.048,0,0,0,87.476,64.1ZM83.341,48.349H74.006a1.556,1.556,0,0,1,0-3.112h9.335a1.556,1.556,0,1,1,0,3.112ZM86.6,43.456a4.652,4.652,0,0,0-3.259-1.331H74.006a4.652,4.652,0,0,0-3.259,1.331A18.614,18.614,0,0,1,60,26.567V9.335H71.671a1.556,1.556,0,0,0,0-3.112H58.447a1.556,1.556,0,0,1,0-3.112H98.9a1.556,1.556,0,0,1,0,3.112H85.674a1.556,1.556,0,0,0,0,3.112H97.343V26.567A18.614,18.614,0,0,1,86.6,43.456Zm21.635-18.562a9.344,9.344,0,0,1-9.179,9.331,21.6,21.6,0,0,0,1.4-7.659V15.559h7.779Z",
    transform: "translate(-46 0)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17445",
    "data-name": "Path 17445",
    d: "M206.849,100.938l-3.489-.618-1.733-3.188h0a3.106,3.106,0,0,0-5.468.024l-1.666,3.127-3.5.651a3.107,3.107,0,0,0-1.744,5.223l2.461,2.553-.452,3.443a3.11,3.11,0,0,0,2.045,3.5,3.091,3.091,0,0,0,2.376-.144l3.184-1.55,3.277,1.561a3.11,3.11,0,0,0,4.417-3.236l-.491-3.511,2.406-2.538a3.111,3.111,0,0,0-1.624-5.3Zm-.606,3.129-2.949,3.111a1.556,1.556,0,0,0-.412,1.286l.6,4.25-3.955-1.884a1.556,1.556,0,0,0-1.35.006l-3.857,1.88c.008-.037.014-.074.019-.111l.555-4.232a1.555,1.555,0,0,0-.423-1.282l-2.984-3.084.053-.009,4.258-.791a1.556,1.556,0,0,0,1.089-.8l2.01-3.783,2.088,3.84a1.555,1.555,0,0,0,1.1.789l4.231.747C206.287,104.021,206.264,104.044,206.243,104.067Z",
    transform: "translate(-166.227 -80.649)",
    fill: "#b23130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17446",
    "data-name": "Path 17446",
    d: "M247.553,43.112a1.556,1.556,0,1,0,0-3.112h0a1.556,1.556,0,0,0,0,3.112Z",
    transform: "translate(-214.88 -33.777)",
    fill: "#b23130"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.cb38c767521974839523e5f7ff711500.svg";
export { ForwardRef as ReactComponent };